import Modal from "react-modal";
import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Moment from "react-moment";
import css from "../TrackerImportData.css";
import { ThreeDots } from "react-loader-spinner";
import Card from "react-bootstrap/Card";
// OLD CODE - Commented out: Using CardHeaderImportData which uses TimeTotal (all entries)
// import CardHeader from "./CardHeaderImportData";
// Updated: Using CardHeaderImportDataCalendar which uses TimeTotalSelected (only selected entries)
import CardHeader from "./CardHeaderImportDataCalendar";
import CardBody from "./CardBodyImportDataCalendar";


const TimeCardImportDataCalendar = ({ index, item, timeFormat, refetchTimerData, invalidEntryIds, setInvalidEntryIds, onEditedIdChange, globalEditedId, setGlobalEditedId }) => {
    // Lift selectedEntries state to parent so header can access it for immediate updates
    const [selectedEntries, setSelectedEntries] = useState(new Set());

    // Initialize selectedEntries based on isSelected field from item data
    // This matches the logic in CardBodyImportDataCalendar.jsx (line 926-945)
    useEffect(() => {
        if (item && Array.isArray(item[1])) {
            const selectedEntryIds = new Set();
            item[1].forEach((entry) => {
                // Check if entry is selected (default to true if isSelected is undefined)
                if (entry && entry._id && entry.isSelected !== false) {
                    selectedEntryIds.add(entry._id);
                }
            });
            setSelectedEntries(selectedEntryIds);
        }
    }, [item]);

    return (
        <Card className="text-center card-bg" >
            <CardHeader index={index} item={item} selectedEntries={selectedEntries} />
            <CardBody 
                item={item} 
                timeFormat={timeFormat} 
                refetchTimerData={refetchTimerData} 
                invalidEntryIds={invalidEntryIds} 
                setInvalidEntryIds={setInvalidEntryIds} 
                onEditedIdChange={onEditedIdChange} 
                globalEditedId={globalEditedId} 
                setGlobalEditedId={setGlobalEditedId}
                selectedEntries={selectedEntries}
                setSelectedEntries={setSelectedEntries}
            />
        </Card>
    );
}
export default TimeCardImportDataCalendar;